import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatRadioModule } from "@angular/material/radio";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTableModule } from "@angular/material/table";
import { ThemeSwitchComponent } from "../theme-switch/theme-switch.component";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "nexu-theme-demo",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatTableModule,
    ThemeSwitchComponent,
  ],
  template: `
    <mat-card>
      <mat-card-header>
        <mat-card-title>Nexu Rebranding 2025 Demo</mat-card-title>
        <mat-card-subtitle>Unified Angular Material Theme</mat-card-subtitle>
      </mat-card-header>

      <mat-card-content>
        <nexu-theme-switch></nexu-theme-switch>

        <h3>Color Palette</h3>
        <div class="color-palette">
          <div class="color-box" style="background-color: var(--primary)">Primary</div>
          <div class="color-box" style="background-color: var(--primary-lighter)">Primary Lighter</div>
          <div class="color-box" style="background-color: var(--primary-darker)">Primary Darker</div>
          <div class="color-box" style="background-color: var(--accent)">Accent</div>
          <div class="color-box" style="background-color: var(--accent-lighter)">Accent Lighter</div>
          <div class="color-box" style="background-color: var(--warn)">Warn</div>
        </div>

        <h3>Buttons</h3>
        <div class="buttons-demo">
          <button mat-button color="primary">Basic</button>
          <button mat-raised-button color="primary">Raised</button>
          <button mat-outlined-button color="primary">Outlined</button>
          <button mat-flat-button color="primary">Flat</button>
          <button mat-fab color="primary">
            <mat-icon>add</mat-icon>
          </button>
          <button mat-mini-fab color="primary">
            <mat-icon>add</mat-icon>
          </button>
        </div>

        <div class="buttons-demo">
          <button mat-button color="accent">Basic</button>
          <button mat-raised-button color="accent">Raised</button>
          <button mat-outlined-button color="accent">Outlined</button>
          <button mat-flat-button color="accent">Flat</button>
          <button mat-fab color="accent">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-mini-fab color="accent">
            <mat-icon>edit</mat-icon>
          </button>
        </div>

        <h3>Button Sizes</h3>
        <h4>Extra Small (xs)</h4>
        <div class="buttons-demo">
          <button mat-button color="primary" class="button-xs">Button</button>
          <button mat-raised-button color="primary" class="button-xs">Raised</button>
          <button mat-outlined-button color="primary" class="button-xs">Outlined</button>
          <button mat-flat-button color="primary" class="button-xs">Flat</button>
          <button mat-fab color="primary" class="button-xs">
            <mat-icon>add</mat-icon>
          </button>
          <button mat-mini-fab color="primary" class="button-xs">
            <mat-icon>add</mat-icon>
          </button>
        </div>

        <h4>Small (sm)</h4>
        <div class="buttons-demo">
          <button mat-button color="primary" class="button-sm">Button</button>
          <button mat-raised-button color="primary" class="button-sm">Raised</button>
          <button mat-outlined-button color="primary" class="button-sm">Outlined</button>
          <button mat-flat-button color="primary" class="button-sm">Flat</button>
          <button mat-fab color="primary" class="button-sm">
            <mat-icon>add</mat-icon>
          </button>
          <button mat-mini-fab color="primary" class="button-sm">
            <mat-icon>add</mat-icon>
          </button>
        </div>

        <h4>Medium (md) - Default</h4>
        <div class="buttons-demo">
          <button mat-button color="primary" class="button-md">Button</button>
          <button mat-raised-button color="primary" class="button-md">Raised</button>
          <button mat-outlined-button color="primary" class="button-md">Outlined</button>
          <button mat-flat-button color="primary" class="button-md">Flat</button>
          <button mat-fab color="primary" class="button-md">
            <mat-icon>add</mat-icon>
          </button>
          <button mat-mini-fab color="primary" class="button-md">
            <mat-icon>add</mat-icon>
          </button>
        </div>

        <h4>Large (lg)</h4>
        <div class="buttons-demo">
          <button mat-button color="primary" class="button-lg">Button</button>
          <button mat-raised-button color="primary" class="button-lg">Raised</button>
          <button mat-outlined-button color="primary" class="button-lg">Outlined</button>
          <button mat-flat-button color="primary" class="button-lg">Flat</button>
          <button mat-fab color="primary" class="button-lg">
            <mat-icon>add</mat-icon>
          </button>
          <button mat-mini-fab color="primary" class="button-lg">
            <mat-icon>add</mat-icon>
          </button>
        </div>

        <h3>Form Controls</h3>
        <div class="form-demo">
          <mat-form-field appearance="outline">
            <mat-label>Name</mat-label>
            <input matInput placeholder="Enter your name" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Email</mat-label>
            <input matInput placeholder="Enter your email" type="email" />
            <mat-icon matSuffix>email</mat-icon>
          </mat-form-field>

          <div>
            <mat-checkbox>Subscribe to newsletter</mat-checkbox>
          </div>

          <div>
            <mat-radio-group>
              <mat-radio-button value="option1">Option 1</mat-radio-button>
              <mat-radio-button value="option2">Option 2</mat-radio-button>
            </mat-radio-group>
          </div>

          <div>
            <mat-slide-toggle>Enable notifications</mat-slide-toggle>
          </div>
        </div>

        <h3>Tabs</h3>
        <mat-tab-group>
          <mat-tab label="First">
            <div class="tab-content">Content for First tab</div>
          </mat-tab>
          <mat-tab label="Second">
            <div class="tab-content">Content for Second tab</div>
          </mat-tab>
          <mat-tab label="Third">
            <div class="tab-content">Content for Third tab</div>
          </mat-tab>
        </mat-tab-group>

        <h3>Table</h3>
        <table mat-table [dataSource]="tableData">
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>ID</th>
            <td mat-cell *matCellDef="let element">{{ element.id }}</td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let element">{{ element.name }}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let element">{{ element.status }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </mat-card-content>
    </mat-card>
  `,
  styles: [
    `
      :host {
        display: block;
        padding: 1rem;
      }

      .color-palette {
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;
        margin-bottom: 2rem;
      }

      .color-box {
        width: 120px;
        height: 80px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        border-radius: 4px;
        font-weight: 500;
        text-align: center;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      }

      .buttons-demo {
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;
        margin-bottom: 1.5rem;
        align-items: center;
      }

      .form-demo {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        max-width: 400px;
        margin-bottom: 2rem;
      }

      .tab-content {
        padding: 1rem;
      }

      table {
        width: 100%;
        margin-bottom: 2rem;
      }

      h4 {
        margin-bottom: 0.5rem;
        margin-top: 1rem;
      }
    `,
  ],
})
export class ThemeDemoComponent {
  tableData = [
    { id: 1, name: "Item One", status: "Active" },
    { id: 2, name: "Item Two", status: "Inactive" },
    { id: 3, name: "Item Three", status: "Active" },
    { id: 4, name: "Item Four", status: "Pending" },
  ];

  displayedColumns: string[] = ["id", "name", "status"];
}
